import cn from 'classnames';
import React from 'react';

type FormSectionProps = {
  title?: string
  error?: boolean
}

/**
 * Default form section
 */
export default function FormSection({title, error, children}: React.PropsWithChildren<FormSectionProps>) {
  return (
    <div className={cn(
      'bg-white px-6 py-5 mb-5 rounded-lg p-6',
      {'border-red border-2 border-opacity-50': error},
    )}>
      {title && <div className="font-bold py-2">{title}</div>}
      <div>
        {children}
      </div>
    </div>
  );
}
